import { useStaticQuery, graphql } from 'gatsby';

interface UseTitlesResponse {
  id: string;
  name: string;
}
export function useTitle(): UseTitlesResponse[] {
  const { allPawsTitle } = useStaticQuery(graphql`
    query {
      allPawsTitle {
        nodes {
          id: remoteId
          name
        }
      }
    }
  `);

  return allPawsTitle.nodes;
}
